/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CreateDirectory from './CreateDirectory/index'
import ImportFromDevices from './ImportFromDevices/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Upload from './Upload/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents/Navigation/Actions"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-5-AjnkD': isMedia.mobile ? "auto" : "0px",'--jc-1-AjnkD': isMedia.mobile ? "flex-start" : "end",'--w-2-AjnkD': isMedia.mobile ? "120px" : "auto",'--mw-3-AjnkD': isMedia.mobile ? "120px" : "100%",'--ox-4-AjnkD': isMedia.mobile ? "auto" : "hidden"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Upload/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Upload/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Upload"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 marginLeft={dtSpaceXxs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'ImportFromDevices/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'ImportFromDevices/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Import from device"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'CreateDirectory/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'CreateDirectory/Content'))}
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="New folder"
/>
)}
</TysiaButton>
</div>
<Upload
  viewPath={`${viewPath}/Upload`}
/>
<CreateDirectory
  viewPath={`${viewPath}/CreateDirectory`}
/>
<ImportFromDevices
  viewPath={`${viewPath}/ImportFromDevices`}
/>
{children}
</React.Fragment>)
}